<template>
  <div v-if="active" class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="close gtm-login-close" @click="close"></div>
      <section class="feedback-container">
        <div class="title is-paddingless">{{ tellUs }}</div>

        <div class="question">
          <span>{{lookFeedback}}</span>
          <form-select v-model="likeLook"></form-select>
        </div>

        <div class="question">
          <span>{{ easyToFind }}</span>
          <form-select v-model="easyFind"></form-select>
        </div>

        <div class="question">
          <span>{{wouldYouRecommend}}</span>
          <form-select v-model="recommendFriend"></form-select>
        </div>

        <div class="question">
          <span>{{anyOtherFeedback}}</span>
          <div class="form">
            <div class="control">
              <textarea v-model="feedback" class="textarea" rows="2"></textarea>
            </div>
          </div>
        </div>

        <div v-if="isError" class="help has-text-danger">{{ unable }}</div>
        <div class="is-expanded saveButton">
          <div class="button is-primary" :class="{'is-loading': inProgress}" :disabled="inProgress" @click="checkLoggedIn">{{ $t('submit') }}</div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import surveyResults from '@/api/survey-results'
import componentState from '@/mixins/component-state'
import auth from '@/mixins/auth'
import i18n from '@/i18n'

import FormSelect from './formselect'

const states = {
  inProgress: 1,
  done: 2,
  error: 3
}

export default {
  mixins: [auth, componentState],
  name: 'feedbackModal',
  components: {
    FormSelect
  },
  props: ['templateActive'],
  data: function () {
    return {
      state: 0,
      active: false,
      error: '',
      likeLook: 'noselection',
      easyFind: 'noselection',
      recommendFriend: 'noselection',
      feedback: '',
      timerId: null,
      time: 1080000,
      lookFeedback: i18n.t('feedbackSurvey.lookFeedback'),
      tellUs: i18n.t('feedbackSurvey.tellUs'),
      easyToFind: i18n.t('feedbackSurvey.easyToFind'),
      wouldYouRecommend: i18n.t('feedbackSurvey.wouldYouRecommend'),
      anyOtherFeedback: i18n.t('feedbackSurvey.anyOtherFeedback'),
      unable: i18n.t('feedbackSurvey.unableToSave')

    }
  },
  computed: {
    isError: function () {
      return this.state === states.error
    },
    inProgress: function () {
      return this.state === states.inProgress
    },
    loginActive: function () {
      return this.$store.getters.modalIsVisible('login')
    },
    isCreatePage: function () {
      return this.$route.params.fromTemplate
    },
    creatingProject: function () {
      return this.isCreatePage || this.templateActive
    }
  },
  mounted: function () {
    this.startTimer()
  },
  watch: {
    creatingProject: function (isCreating) {
      isCreating ? this.stopTimer() : this.startTimer()
    },
    loginActive: function (isSigningUp) {
      isSigningUp ? this.stopTimer() : this.resetTimer()
    }
  },
  methods: {
    close: function () {
      this.enabled = false
      this.active = false
    },
    save: function () {
      this.state = states.inProgress
      surveyResults.send(this.likeLook, this.easyFind, this.recommendFriend, this.feedback, this.$isEngCom).then(() => {
        this.state = states.done
        this.close()
      }, (error) => {
        this.state = states.done
        this.error = error.message
      })
    },
    checkLoggedIn: function () {
      if (!this.isLoggedIn) {
        this.close()
        this.$store.dispatch('showLoginModal', { source: 'feedback-survey', callback: this.save, signupMessage: 'Sign up to save your feedback to your account or close to submit anonomously.' })
      } else {
        this.save()
      }
    },
    checkShow: function () {
      if (!this.libs.auth.isFeedbackSurveySeen()) {
        if (this.isLoggedIn) {
          this.$store.dispatch('getUserSetting', 'feedbackSurveySeen').then((seen) => {
            if (!seen) {
              this.show()
            }
          })
        } else {
          this.show()
        }
      }
    },
    show: function () {
      this.active = true
      this.disableFeedbackSurvey()
    },
    disableFeedbackSurvey: function () {
      this.libs.auth.setFeedbackSurveySeen(true)
      if (this.isLoggedIn) {
        const settings = { feedbackSurveySeen: true }
        this.$store.dispatch('updateUserSettings', { username: this.currentUser.userName, settings })
      }
    },
    startTimer: function () {
      this.timerId = setInterval(() => {
        this.time -= 1000
        if (this.time < 1) {
          this.stopTimer()
          this.checkShow()
        }
      }, 1000)
    },
    stopTimer: function () {
      clearInterval(this.timerId)
    },
    resetTimer: function () {
      this.time = 180000
      this.startTimer()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .feedback-container {
    padding: 1rem;
    @include mobile {
      padding: 0.3rem;
    }
  }

  .modal-card {
    width: 53vw;
    max-width: 500px;
    background: #F2F2F2;
    padding: 0.5rem;
    text-align: center;
    border-radius: 0.5rem;
    @include mobile {
      width: 100vw;
      padding: 1rem;
    }
  }

  .close {
    position: absolute;
    top: 15px;
    right: 20px;
    width: 20px;
    height: 20px;
    opacity: 0.5;
    cursor: pointer;
  }

  .close:hover {
    opacity: 1;
  }

  .close:before, .close:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 21px;
    width: 1px;
    background-color: #333;
  }

  .close:before {
    transform: rotate(45deg);
  }
  .close:after {
    transform: rotate(-45deg);
  }

  .question {
    span {
      font-size: 1.25rem;
      font-weight: 500;
    }
    padding-top: 1.4rem;
    @include mobile {
      padding-top: 1.6rem;
      font-weight: 600;
      span{
        padding-top: 0rem;
        font-size: 1rem;
      }
    }
  }

  .title {
    font-weight: 500;
    margin: 1rem auto 0.5rem auto;
    @include mobile {
      font-size: 1.2rem;
    }
  }

  .saveButton {
    margin-top: 1rem;
    align-items: center;
  }

  .control {
    max-width: 400px;
    margin: 0 auto;
  }

  .button {
    text-transform: uppercase;
    border-radius: 0;
    padding: 1.1rem;
    font-size: 0.9rem;
  }

</style>
